import React from 'react';

import { connect } from "react-redux"//联系store的组件
import evn from "./../../../actions/index"//action的所有事件

import "./CaseDetailsInfo.css"//引入样式
import CaseDetailsInfo from "./CaseDetailsInfo.js"//引入组件
import { Button,Modal } from 'antd';//引入antd组件

let _App = null;
class App extends React.Component {
    state = {
        cid: 0,
        type: '',//页面来源
    };

    //点击确定事件
    handleOk = (e) => {
        this.props.dispatch(evn.hideCaseInfo(this.props.caseId))
    };

    componentWillReceiveProps(e) {
        //this.setState({ cid: e.caseId }, () => {
        //    this.handleData();
        //})
    }

    //点击取消事件
    handleCancel = (e) => {
        this.props.dispatch(evn.hideCaseInfo(this.props.caseId))
    };

    //渲染组件
    render() {
        return (
            <div id="caseModal">
                <Modal 
                    title="查看"
                    visible={this.props.visible}
                    footer={[
                        <Button onClick={this.handleOk}>
                            返回列表
                      </Button>,
                    ]}

                    onCancel={this.handleCancel}
                    width="1000px"
                >
                   <CaseDetailsInfo cid={this.props.caseId} type={this.props.fromType} />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    //console.log('caseState', state)
    return {
        caseId: state.CaseDetailsInfo.caseId,
        visible: state.CaseDetailsInfo.visible,
        fromType: state.CaseDetailsInfo.fromType
    }
};
export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/components/Content/Common/CaseDetailsInfoModal.js